import $ from "jquery";

$(document).ready(function(){
  if ($('.submitQuote'.length)){

    $(document).on('click', '.submitQuote', function(e) {
      var inputCheckContractType = document.getElementById('contract_type');
      if(inputCheckContractType.value == 1){
        var inputCheckType1 = document.getElementById('contract_amount');
        if(inputCheckType1.value === '' || inputCheckType1.value == 0){
          $('#errorTxtContractAmount').text('金額を入力してください。');
          return false;
        }
      }else{
        var inputCheckType2HourlySalary = document.getElementById('hourly_salary');
        var count =0;

        if(inputCheckType2HourlySalary.value === '' || inputCheckType2HourlySalary.value == 0){
          $('#errorTxtHourlySalary').text('金額を入力してください。');
          count = count +1;
        }else{
          $('#errorTxtHourlySalary').text('');
        }
        var inputCheckType2WorkingTimeMonth = document.getElementById('working_time_month');
        if(inputCheckType2WorkingTimeMonth.value === '' || inputCheckType2WorkingTimeMonth.value == 0 ){
          $('#errorTxtWorkingTimeMonth').text('金額を入力してください。');
          count = count +1;
        }else{
          $('#errorTxtWorkingTimeMonth').text('');
        }
        // var inputCheckType2WorkingMonth = document.getElementById('working_month');
        // if(inputCheckType2WorkingMonth.value === '' || inputCheckType2WorkingMonth.value == 0 ){
        //   $('#errorTxtWorkingMonth').text('金額を入力してください。');
        //   count = count +1;
        // }else{
        //   $('#errorTxtWorkingMonth').text('');
        // }

        if(count >0){
          return false;
        }
      }
      e.preventDefault();
      var formData = $('#formQuote').serialize();
      $.ajax({
        url: `${url_ajax_chat}`,
        data: formData,
        type: 'post',
        dataType: "json",
        error: function(res) {
          if(res.responseJSON.errors){
            if(typeof  res.responseJSON.errors.hourly_salary !== 'undefined'){
              $('#errorTxtHourlySalary').text(res.responseJSON.errors.hourly_salary);
            }
            if(typeof  res.responseJSON.errors.contract_amount !== 'undefined'){
              $('#errorTxtContractAmount').text(res.responseJSON.errors.contract_amount);
            }
            if(typeof  res.responseJSON.errors.working_time_month !== 'undefined'){
              $('#errorTxtWorkingTimeMonth').text(res.responseJSON.errors.working_time_month);
            }
          }else{
            alert('金額を入力してください。');
          }
      }
        }).done(function (res) {
          location.reload();
        });
    });
}

});
